// extracted by mini-css-extract-plugin
export default {"content":"_2XbhEsS0","swiper":"QnbvWe1q","noSwiping":"_2zN_ACNB"};